import Api from '../../api'
import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects'
import {
  CHANGE_USER_ACCOUNT,
  LOGOUT,
} from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { addSettings } from 'portal-modules/common/redux/modules/settings'
import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'
import { requestAlerts } from 'portal-modules/alerts-panel/redux/modules/alerts'

// action types
export const SET_RENEWAL_REVIEWED = 'rp/renewal/SET_RENEWAL_REVIEWED'
export const SET_RENEWAL_OFFER_REQUESTED =
  'rp/renewal/SET_RENEWAL_OFFER_REQUESTED'
export const RESET_RENEWAL_REVIEWED = 'rp/renewal/RESET_RENEWAL_REVIEWED'
export const REQUEST_RENEWAL_OFFERS = 'rp/renewal/REQUEST_RENEWAL_OFFERS'
export const RECEIVE_RENEWAL_OFFERS = 'rp/renewal/RECEIVE_RENEWAL_OFFERS'
export const REQUEST_COMPLETE_RENEWAL = 'rp/renewal/REQUEST_COMPLETE_RENEWAL'
export const COMPLETED_RENEWAL_OFFER = 'rp/renewal/COMPLETED_RENEWAL_OFFER'
export const PROCESS_TRANSFER_REQUEST = 'rp/renewal/PROCESS_TRANSFER_REQUEST'
export const SEND_RENEWAL_SIGNAL = 'rp/renewal/SEND_RENEWAL_SIGNAL'
// export const REQUEST_AUTOPAYMENTS = 'rp/renewal/REQUEST_AUTOPAYMENTS'
// export const RECEIVE_AUTOPAYMENTS = 'rp/renewal/RECEIVE_AUTOPAYMENTS'
// export const AUTO_PAYMENT_SAVE = 'rp/renewal/AUTO_PAYMENT_SAVE'
// export const AUTO_PAYMENT_SAVED = 'rp/renewal/AUTO_PAYMENT_SAVED'
// export const DELETE_PAYMENT = 'rp/renewal/DELETE_PAYMENT'
export const REQUEST_PET_DETAILS = 'rp/renewal/REQUEST_PET_DETAILS'
export const RECEIVE_PET_DETAILS = 'rp/renewal/RECEIVE_PET_DETAILS'
export const ADD_RENEWAL_PET = 'rp/renewal/ADD_RENEWAL_PET'
export const EDIT_RENEWAL_PET = 'rp/renewal/EDIT_RENEWAL_PET'
export const SAVE_FLOOR_PLAN_DETAILS = 'rp/renewal/SAVE_FLOOR_PLAN_DETAILS'
export const FLOOR_PLAN_DETAILS_SAVED = 'rp/renewal/FLOOR_PLAN_DETAILS_SAVED'
export const DELETE_RENEWAL_PET = 'rp/renewal/DELETE_RENEWAL_PET'
export const REQUEST_RENEWAL_PERSONAL_INFO =
  'rp/renewal/REQUEST_RENEWAL_PERSONAL_INFO'
export const RECEIVE_RENEWAL_PERSONAL_INFO =
  'rp/renewal/RECEIVE_RENEWAL_PERSONAL_INFO'
export const UPDATE_RENEWAL_PERSONAL_INFO =
  'rp/renewal/UPDATE_RENEWAL_PERSONAL_INFO'
export const UPDATE_INCENTIVES_INFO = 'rp/renewal/UPDATE_INCENTIVES_INFO'
export const UPDATE_SELECTED_SPECIALS = 'rp/renewal/UPDATE_SELECTED_SPECIALS'
export const REQUEST_OCCUPANTS_INFO = 'rp/renewal/REQUEST_OCCUPANTS_INFO'
export const RECEIVE_OCCUPANTS_INFO = 'rp/renewal/RECEIVE_OCCUPANTS_INFO'
export const DELETE_OCCUPANTS_INFO = 'rp/renewal/DELETE_OCCUPANTS_INFO'
export const OCCUPANTS_INFO_DELETED = 'rp/renewal/OCCUPANTS_INFO_DELETED'
export const ADD_OCCUPANTS_INFO = 'rp/renewal/ADD_OCCUPANTS_INFO'
export const REQUEST_RENEWAL_EMPLOYERS = 'rp/renewal/REQUEST_RENEWAL_EMPLOYERS'
export const RECEIVE_RENEWAL_EMPLOYERS = 'rp/renewal/RECEIVE_RENEWAL_EMPLOYERS'
export const ADD_RENEWAL_EMPLOYER = 'rp/renewal/ADD_RENEWAL_EMPLOYER'
export const UPDATE_RENEWAL_EMPLOYER = 'rp/renewal/UPDATE_RENEWAL_EMPLOYER'
export const DELETE_RENEWAL_EMPLOYER = 'rp/renewal/DELETE_RENEWAL_EMPLOYER'
export const REQUEST_RENTED_ITEMS = 'rp/renewal/REQUEST_RENTED_ITEMS'
export const RECEIVE_RENTED_ITEMS = 'rp/renewal/RECEIVE_RENTED_ITEMS'
export const REQUEST_REMOVE_RENTED_ITEM =
  'rp/renewal/REQUEST_REMOVE_RENTED_ITEM'
export const CREATE_MTOM_INTERVAL = 'rp/renewal/CREATE_MTOM_INTERVAL'

export const REQUEST_FLOORPLAN_DETAILS = 'rp/renewal/REQUEST_FLOORPLAN_DETAILS'
export const REQUEST_FLOORPLAN_LEASETERM =
  'rp/renewal/REQUEST_FLOORPLAN_LEASETERM'

export const RECEIVE_FLOORPLAN_DETAILS = 'rp/renewal/RECEIVE_FLOORPLAN_DETAILS'
export const RECEIVE_FLOORPLAN_LEASE_TERM =
  'rp/renewal/RECEIVE_FLOORPLAN_LEASE_TERM'

export const REQUEST_TRANSFER_UNIT_SEARCH =
  'rp/renewal/REQUEST_TRANSFER_UNIT_SEARCH'
export const RECEIVE_TRANSFER_UNIT_SEARCH =
  'rp/renewal/RECEIVE_TRANSFER_UNIT_SEARCH'
export const PROCESS_RENEWAL_REQUEST = 'rp/renewal/PROCESS_RENEWAL_REQUEST'
import createFormAction from 'portal-modules/common/redux/create-form-action'
export const CANCEL_RENEWAL_REQUEST = 'rp/renewal/CANCEL_RENEWAL_REQUEST'
export const REQUEST_CANCEL_RENEWAL_REQUEST =
  'rp/renewal/REQUEST_CANCEL_RENEWAL_REQUEST'
export const GET_RENEWAL_REQUEST_DETAILS =
  'rp/renewal/GET_RENEWAL_REQUEST_STATUS'
export const RECIEVE_RENEWAL_REQUEST_DETAILS =
  'rp/renewal/RECIEVE_RENEWAL_REQUEST_DETAILS'
export const REQUEST_INCENTIVES = 'rp/renewal/REQUEST_INCENTIVES'
export const RECEIVE_INCENTIVES = 'rp/renewal/RECEIVE_INCENTIVES'

// action creators
export const setRenewalReviewed = payload => ({
  type: SET_RENEWAL_REVIEWED,
  payload,
})

export const setRenewalOffersRequested = () => ({
  type: SET_RENEWAL_OFFER_REQUESTED,
})

export const resetRenewalReviewed = () => ({
  type: RESET_RENEWAL_REVIEWED,
})

export const requestRenewalOffers = () => ({
  type: REQUEST_RENEWAL_OFFERS,
})

export const requestRentedItems = payload => ({
  type: REQUEST_RENTED_ITEMS,
  payload,
})

export const requestRemoveRentedItem = payload => ({
  type: REQUEST_REMOVE_RENTED_ITEM,
  payload,
})

export const receiveRenewalOffers = payload => ({
  type: RECEIVE_RENEWAL_OFFERS,
  payload: {
    application_id: payload.application_id,
    is_student_property: payload.is_student_property,
    leaseEndDate: payload.lease_end_date,
    currentRent: payload.current_rent,
    current_rent_tax_amount: payload.current_rent_tax_amount,
    offers: { ...payload.quotes },
    monthToMonth: payload.month_to_month,
  },
})

// export const requestAutoPayments = () => ({
//   type: REQUEST_AUTOPAYMENTS,
// })

// export const saveRenewalAutoPayment = (payload, callback) => ({
//   type: AUTO_PAYMENT_SAVE,
//   callback,
//   payload,
// })

// export const deleteAutoPayment = payload => ({
//   type: DELETE_PAYMENT,
//   payload,
// })

export const requestPetsDetails = payload => ({
  type: REQUEST_PET_DETAILS,
  payload,
})

export const receivePetDetails = payload => ({
  type: RECEIVE_PET_DETAILS,
  payload,
})

export const addRenewalPet = payload => ({
  type: ADD_RENEWAL_PET,
  payload,
})

export const updatePetDetails = payload => ({
  type: EDIT_RENEWAL_PET,
  payload,
})

export const saveFloorPlanUnitDetails = payload => ({
  type: SAVE_FLOOR_PLAN_DETAILS,
  payload,
})

export const addFloorPlanDetails = payload => ({
  type: FLOOR_PLAN_DETAILS_SAVED,
  payload,
})

export const deleteRenewalPet = payload => ({
  type: DELETE_RENEWAL_PET,
  payload,
})

export const requestRenewalPersonalInfo = payload => ({
  type: REQUEST_RENEWAL_PERSONAL_INFO,
  payload,
})

export const receiveRenewalPersonalInfo = payload => ({
  type: RECEIVE_RENEWAL_PERSONAL_INFO,
  payload,
})

export const updateRenewalPersonalInfo = payload => ({
  type: UPDATE_RENEWAL_PERSONAL_INFO,
  payload,
})

export const updateIncentivesInfo = payload => ({
  type: UPDATE_INCENTIVES_INFO,
  payload,
})

export const updateSelectedSpecials = payload => ({
  type: UPDATE_SELECTED_SPECIALS,
  payload,
})

export const requestOccupantInfo = payload => ({
  type: REQUEST_OCCUPANTS_INFO,
  payload,
})

export const receiveOccupantInfo = payload => ({
  type: RECEIVE_OCCUPANTS_INFO,
  payload: {
    occupants: payload,
    // occupants: {
    //   [payload.id]: { ...payload },
    // },
  },
})

export const requestCompleteRenewal = ({ payload, callback }) => ({
  type: REQUEST_COMPLETE_RENEWAL,
  payload,
  callback,
})

export const processTransferRequest = ({ payload, callback }) => ({
  type: PROCESS_TRANSFER_REQUEST,
  payload,
  callback,
})

export const completedRenewal = payload => ({
  type: COMPLETED_RENEWAL_OFFER,
  payload,
})

export const deleteOccupantInfo = payload => ({
  type: DELETE_OCCUPANTS_INFO,
  payload,
})

export const requestRenewalEmployers = payload => ({
  type: REQUEST_RENEWAL_EMPLOYERS,
  payload,
})

export const receiveRenewalEmployers = payload => ({
  type: RECEIVE_RENEWAL_EMPLOYERS,
  payload,
})

export const addRenewalEmployer = payload => ({
  type: ADD_RENEWAL_EMPLOYER,
  payload,
})

export const addRenewalOccupant = payload => ({
  type: ADD_OCCUPANTS_INFO,
  payload,
})

export const updateRenewalEmployer = payload => ({
  type: UPDATE_RENEWAL_EMPLOYER,
  payload,
})

export const deleteRenewalEmployer = payload => ({
  type: DELETE_RENEWAL_EMPLOYER,
  payload,
})

export const receiveRentedItems = payload => ({
  type: RECEIVE_RENTED_ITEMS,
  payload: payload,
})

export const createMtomInterval = (payload, callback) => ({
  type: CREATE_MTOM_INTERVAL,
  payload,
  callback,
})

export const requestFloorplanDetails = payload => ({
  type: REQUEST_FLOORPLAN_DETAILS,
  payload,
})

export const requestFloorplanLeaseTerm = payload => ({
  type: REQUEST_FLOORPLAN_LEASETERM,
  payload,
})

export const receiveFloorplanDetails = payload => ({
  type: RECEIVE_FLOORPLAN_DETAILS,
  payload,
})

export const receiveFloorplanLeaseTerm = payload => ({
  type: RECEIVE_FLOORPLAN_LEASE_TERM,
  payload,
})

export const requestTransferUnitSearch = ({ payload, callback }) => ({
  type: REQUEST_TRANSFER_UNIT_SEARCH,
  payload,
  callback,
})

export const receiveTransferUnitSearch = payload => ({
  type: RECEIVE_TRANSFER_UNIT_SEARCH,
  payload,
})

export const receiveRenewalRequestDetails = payload => ({
  type: RECIEVE_RENEWAL_REQUEST_DETAILS,
  payload,
})

export const getRenewalRequestDetails = () => ({
  type: GET_RENEWAL_REQUEST_DETAILS,
})

export const requestCancelRenewalRequest = () => ({
  type: REQUEST_CANCEL_RENEWAL_REQUEST,
})

export const processRenewalRequest = createFormAction(PROCESS_RENEWAL_REQUEST)

export const requestIncentives = payload => ({
  type: REQUEST_INCENTIVES,
  payload,
})

export const receiveIncentives = payload => ({
  type: RECEIVE_INCENTIVES,
  payload: payload,
})

export const sendRenewalSignal = (payload, callback) => ({
  type: SEND_RENEWAL_SIGNAL,
  payload,
  callback,
})

// reducer
export default (state = { emergencyContact: [] }, { payload, type }) => {
  switch (type) {
    case RECEIVE_OCCUPANTS_INFO:
    case RECEIVE_PET_DETAILS:
    case RECEIVE_RENEWAL_EMPLOYERS:
    case RECEIVE_RENEWAL_OFFERS:
    case COMPLETED_RENEWAL_OFFER:
      return { ...state, ...payload }
    case SET_RENEWAL_REVIEWED:
      return { ...state, reviewed: { ...state.reviewed, [payload]: true } }
    // case RECEIVE_AUTOPAYMENTS:
    //   return {
    //     ...state,
    //     autoPayments: payload,
    //     initAutoPaymentIds: Object.values(payload).reduce(
    //       (acc, { id }) => [...acc, id],
    //       [],
    //     ),
    //   }
    // case AUTO_PAYMENT_SAVED:
    //   return {
    //     ...state,
    //     autoPayments: {
    //       ...state.autoPayments,
    //       [payload.id]: { ...payload, is_renewal: true },
    //     },
    //   }
    // case DELETE_PAYMENT:
    //   return {
    //     ...state,
    //     autoPayments: Object.keys(state.autoPayments).reduce(
    //       (acc, key) =>
    //         key == payload.id
    //           ? acc
    //           : { ...acc, [key]: state.autoPayments[key] },
    //       {},
    //     ),
    //   }
    case RECEIVE_RENEWAL_PERSONAL_INFO:
    case UPDATE_RENEWAL_PERSONAL_INFO:
      return { ...state, personalInfo: payload }
    case UPDATE_INCENTIVES_INFO:
      return { ...state, incentives: payload }
    case UPDATE_SELECTED_SPECIALS:
      return { ...state, updatedSelectedSpecials: payload }
    case OCCUPANTS_INFO_DELETED:
      return Object.values(state.occupants).reduce((obj, occupant) => {
        if (occupant.id === payload) return obj
        return { ...obj, [occupant.id]: occupant }
      }, {})
    case ADD_RENEWAL_EMPLOYER:
      return state.employers
        ? { ...state, employers: [...state.employers, payload] }
        : { ...state, employers: [payload] }
    case ADD_OCCUPANTS_INFO:
      return {
        ...state,
        occupants: [...state.occupants, payload],
      }
    case UPDATE_RENEWAL_EMPLOYER:
      return {
        ...state,
        employers: state.employers.map(item => {
          if (item.id != payload.index) {
            return item
          }
          return {
            ...item,
            ...payload.value,
          }
        }),
        employersError: state.employersError.filter(
          item => item !== payload.value.id,
        ),
      }
    case DELETE_RENEWAL_EMPLOYER:
      return {
        ...state,
        employers: state.employers.map(item =>
          item.id != payload ? item : { ...item, is_deleted: true },
        ),
        employersError: state.employersError.filter(
          item => item !== payload,
        ),
      }
    case ADD_RENEWAL_PET:
      return { ...state, pets: [...state.pets, payload] }
    case EDIT_RENEWAL_PET:
      return { ...state, pets: payload }

    case FLOOR_PLAN_DETAILS_SAVED:
      return { ...state, selectedFloorPlanDetails: { ...payload } }
    case DELETE_RENEWAL_PET: {
      const pets = state.pets
      pets.splice(payload, 1)
      return {
        ...state,
        pets: pets,
      }
    }
    case RECEIVE_RENTED_ITEMS:
      return { ...state, rentedItems: payload }
    case REQUEST_REMOVE_RENTED_ITEM:
      return {
        ...state,
        rentedItems: state.rentedItems.map(item => {
          if (item.id !== Number(payload)) {
            return item
          }
          return {
            ...item,
            is_deleted: true,
          }
        }),
      }
    case CREATE_MTOM_INTERVAL:
      return { ...state, payload }
    case RESET_RENEWAL_REVIEWED:
    case CHANGE_USER_ACCOUNT:
    case LOGOUT:
      return {}
    case RECEIVE_FLOORPLAN_DETAILS:
      return { ...state, floorplans: payload }
    case RECEIVE_FLOORPLAN_LEASE_TERM:
      return { ...state, propertyLeaseTerms: { ...payload } }
    case RECEIVE_TRANSFER_UNIT_SEARCH:
      return { ...state, ...payload }
    case SET_RENEWAL_OFFER_REQUESTED:
      return { ...state, requested: true }
    case RECIEVE_RENEWAL_REQUEST_DETAILS:
      return {
        ...state,
        ...payload,
      }
    case RECEIVE_INCENTIVES: {
      const formatPayload = Object.values(payload)
      return { ...state, incentives: formatPayload }
    }
    case CANCEL_RENEWAL_REQUEST:
      return {
        ...state,
        renewalRequest: { status: null },
      }
    default:
      return state
  }
}

// sagas
export function* fetchIncentives({ payload }) {
  const response = yield call(Api.getRenewalIncentives, {
    offer_id: payload.quoteTermId,
    offer_lease_id: payload.offerLeaseId ? payload.offerLeaseId : '',
  })

  if (response) {
    const { incentives, settings } = response
    yield put(receiveIncentives(incentives))
  }
}

export function* watchRequestIncentives() {
  yield takeLatest(
    REQUEST_INCENTIVES,
    createRequestSaga(fetchIncentives, {
      key: 'renewal',
      message: __('Looking for incentives'),
    }),
  )
}

export function* fetchRenewalOffers() {
  yield put(setRenewalOffersRequested())
  const {
    settings,
    is_student_property,
    property_map,
    offer_lease_id,
    is_renewal_transfer,
    application_id,
    is_hide_pet_section,
    is_stack_renewal,
    ...rest
  } = yield call(Api.getRenewalOffers)

  let actions = [
    receiveRenewalOffers({ ...rest, application_id, is_student_property }),
  ]

  if (settings && Object.keys(settings).length) {
    actions.push(
      addSettings({
        renewal: {
          ...settings,
          is_student_property,
          property_map,
          offer_lease_id,
          is_renewal_transfer,
          application_id,
          is_hide_pet_section,
          is_stack_renewal,
        },
      }),
    )
  }
  yield all(actions.map(a => put(a)))
}

export function* fetchOccupantInfo({ payload }) {
  const { occupants, settings, customer_relationships } = yield call(
    Api.getOccupantsInfo,
    {
      id: payload.quoteTermId,
      offer_lease_id: payload.offerLeaseId ? payload.offerLeaseId : '',
    },
  )

  let actions = [receiveOccupantInfo(occupants)]

  if (occupants.length && settings) {
    actions.push(
      addSettings({ occupants: { ...settings, customer_relationships } }),
    )
  }
  yield all(actions.map(a => put(a)))
}

function* deleteOccupant({ payload }) {
  yield put({ type: OCCUPANTS_INFO_DELETED, payload })
}

export function* watchRequestRenewalOffers() {
  yield takeLatest(
    REQUEST_RENEWAL_OFFERS,
    createRequestSaga(fetchRenewalOffers, {
      key: 'renewal',
      message: __('Looking for renewal offers'),
    }),
  )
}

// const getAllowedDays = str => str.split(',').map(d => +d)

// const getSettings = ({
//   allowed_days,
//   bimonthly,
//   end_date_options,
//   ...rest
// }) => ({
//   ...rest,
//   allowed_days: getAllowedDays(allowed_days),
//   bimonthly: {
//     ...bimonthly,
//     allowed_days: getAllowedDays(bimonthly.allowed_days),
//   },
//   end_date_options,
// })

export function* watchRequestCompleteRenewal() {
  yield takeLatest(
    REQUEST_COMPLETE_RENEWAL,
    createRequestSaga(completeRenewalOffer, {
      key: 'renewal',
      message: __('Completing renewal offer'),
      write: true,
    }),
  )
}

export function* completeRenewalOffer({ payload, callback }) {
  const { sucess, file_id } = yield call(
    Api.postRenewalCompleteRequest,
    payload,
  )

  if (sucess) {
    yield put({
      type: COMPLETED_RENEWAL_OFFER,
      payload: { ...payload, file_id },
    })
  }
  yield put(requestAlerts())
  typeof callback === 'function' && callback(file_id)
}

export function* watchFloorPlanUnitDetails() {
  yield takeLatest(
    SAVE_FLOOR_PLAN_DETAILS,
    createRequestSaga(processFloorPlanUnitDetails, {
      key: 'saveFloorPlanUnitDetails',
      message: __('Saving Floor Plan and Unit Details'),
    }),
  )
}

export function* processFloorPlanUnitDetails({ payload }) {
  const { callback, ...rest } = payload
  yield put(addFloorPlanDetails(rest))
  yield put(setRenewalReviewed('select_a_floor_plan'))
  typeof callback === 'function' && callback()
}

// function* fetchAutoPayments() {
//   const { list, settings } = yield call(Api.getAutoPayments)
//   const autoPayments = Object.entries(list).reduce((obj, [key, value]) => {
//     if (!Array.isArray(value)) return obj
//     return {
//       ...obj,
//       ...value.reduce(
//         (valObj, payment) => ({
//           ...valObj,
//           [payment.id ? payment.id : payment.first_payment.id]: {
//             ...payment,
//             type: key,
//             id: payment.id ? payment.id : payment.first_payment.id,
//           },
//         }),
//         {},
//       ),
//     }
//   }, {})

//   if (Object.keys(autoPayments).length) {
//     yield put({ type: RECEIVE_AUTOPAYMENTS, payload: autoPayments })
//   }

//   if (Object.keys(settings).length) {
//     yield put(addSettings({ scheduledPayments: getSettings(settings) }))
//   }
// }

// function* watchRequestAutoPayments() {
//   yield takeLatest(
//     REQUEST_AUTOPAYMENTS,
//     createRequestSaga(fetchAutoPayments, {
//       key: 'renewal',
//       message: __('Checking for auto payments'),
//     }),
//   )
// }

// function* saveAutoPaymentForRenewal({ payload: { payload, callback } }) {
//   yield put({ type: AUTO_PAYMENT_SAVED, payload })
//   if (typeof callback === 'function') callback()
// }

// function* watchAutopaymentSaveForRenewal() {
//   yield takeEvery(
//     AUTO_PAYMENT_SAVE,
//     createRequestSaga(saveAutoPaymentForRenewal, {
//       key: 'renewal',
//       message: __('Saving auto payment'),
//       successMessage: __('Auto payment saved'),
//       write: true,
//     }),
//   )
// }

export function* fetchPetDetails({ payload }) {
  const { pets, settings } = yield call(Api.getRenewalPetDetails, payload)
  let actions = [
    {
      type: RECEIVE_PET_DETAILS,
      payload: { pets: pets || [] },
    },
  ]

  if (settings && Object.keys(settings).length) {
    actions.push(
      addSettings({
        renewalPets: {
          ...settings,
          pet_types: settings.pet_types.reduce(
            (obj, type) => ({ ...obj, [type.id]: type }),
            {},
          ),
        },
      }),
    )
  }

  yield all(actions.map(a => put(a)))
}

export function* watchPetDetails() {
  yield takeLatest(
    REQUEST_PET_DETAILS,
    createRequestSaga(fetchPetDetails, {
      key: 'renewal',
      message: __('Looking for pets'),
    }),
  )
}

export function* fetchRenewalPersonalInfo({ payload }) {
  const personalInfo = yield call(Api.getRenewalPersonalInfo, {
    offer_id: payload.quoteTermId,
    offer_lease_id: payload.offerLeaseId ? payload.offerLeaseId : '',
  })

  let actions = []
  if (personalInfo) {
    actions.push({
      type: RECEIVE_RENEWAL_PERSONAL_INFO,
      payload: personalInfo.customer_info,
    })
  }
  if (Object.keys(personalInfo.settings).length) {
    actions.push(addSettings({ renewalPersonalInfo: personalInfo.settings }))
  }
  yield all(actions.map(a => put(a)))
}

export function* watchRequestRenewalPersonalInfo() {
  yield takeLatest(
    REQUEST_RENEWAL_PERSONAL_INFO,
    createRequestSaga(fetchRenewalPersonalInfo, {
      key: 'renewal',
      message: __('Looking for your information'),
    }),
  )
}

export function* watchRequestOccupantInfo() {
  yield takeLatest(
    REQUEST_OCCUPANTS_INFO,
    createRequestSaga(fetchOccupantInfo, {
      key: 'renewal',
      message: __('Looking for occupant info'),
    }),
  )
}

function* watchDeleteOccupant() {
  yield takeEvery(
    DELETE_OCCUPANTS_INFO,
    createRequestSaga(deleteOccupant, {
      key: 'renewal',
      message: __('Deleting occupant'),
      successMessage: __('Occupant successfully deleted'),
      write: true,
    }),
  )
}

export function* fetchRenewalEmployers({ payload }) {
  const { employers, settings, errors } = yield call(Api.getRenewalEmployers, {
    offer_id: payload.quoteTermId,
    offer_lease_id: payload.offerLeaseId ? payload.offerLeaseId : '',
  })
  yield put(addSettings({ employer_info_settings: settings }))
  yield put(
    receiveRenewalEmployers({
      employers: employers || [],
      employersError: errors || [],
    }),
  )
}

export function* watchRequestRenewalEmployers() {
  yield takeLatest(
    REQUEST_RENEWAL_EMPLOYERS,
    createRequestSaga(fetchRenewalEmployers, {
      key: 'renewal',
      message: __('Looking for renewal employers'),
    }),
  )
}

export function* fetchRentedItems({ payload }) {
  const response = yield call(Api.getRenewalRentedItems, {
    offer_id: payload.quoteTermId,
    offer_lease_id: payload.offerLeaseId ? payload.offerLeaseId : '',
  })

  let actions = []
  if (response) {
    const { add_ons, settings } = response

    actions.push(receiveRentedItems(add_ons))

    if (Object.keys(settings).length) {
      actions.push(
        addSettings({
          allow_renewal_remove_addons: settings.allow_remove_addons,
        }),
      )
    }
  }

  yield all(actions.map(a => put(a)))
}

export function* watchRequestRentedItems() {
  yield takeLatest(
    REQUEST_RENTED_ITEMS,
    createRequestSaga(fetchRentedItems, {
      key: 'renewal',
      message: __('Looking for add-ons'),
    }),
  )
}

function* createMonthToMonth({ payload, callback }) {
  const result = yield call(Api.createMtomInterval, { payload })
  if (result === true && typeof callback === 'function') {
    yield put(resetRenewalReviewed())
    callback()
  }
}

export function* watchCreateMtomInterval() {
  yield takeEvery(
    CREATE_MTOM_INTERVAL,
    createRequestSaga(createMonthToMonth, {
      key: 'renewal',
      message: __('Cancelling renewal'),
      successMessage: __('Renewal successfully cancelled'),
      write: true,
    }),
  )
}

export function* fetchFloorplanDetails({ payload }) {
  const floorplan = yield call(Api.getTransferFloorplans, {
    application_id: payload.application_id,
    lease_term_id: payload.lease_term_id ? payload.lease_term_id : 0,
    lease_start_window_id: payload.lease_start_window_id
      ? payload.lease_start_window_id
      : 0,
  })

  let actions = []
  if (floorplan) {
    actions.push({
      type: RECEIVE_FLOORPLAN_DETAILS,
      payload: floorplan,
    })
  }

  yield all(actions.map(a => put(a)))
}

export function* fetchFloorplanLeaseTerm({ payload }) {
  const { property_lease_terms } = yield call(Api.getFloorplanLeaseTerms, {
    application_id: payload.application_id,
  })
  yield put(receiveFloorplanLeaseTerm(property_lease_terms))
}

export function* getTransferUnitSearch({ payload, callback }) {
  const { unit_spaces } = yield call(Api.getListTransferUnitSearch, {
    ...payload,
  })
  yield put(receiveTransferUnitSearch({ unit_spaces: unit_spaces }))
  typeof callback === 'function' && callback()
}

export function* watchFloorplanLeaseTerm() {
  yield takeLatest(
    REQUEST_FLOORPLAN_LEASETERM,
    createRequestSaga(fetchFloorplanLeaseTerm, {
      key: 'floor_plan_leases',
      message: __('Looking for floor plans lease term'),
    }),
  )
}

export function* watchFloorplanDetails() {
  yield takeLatest(
    REQUEST_FLOORPLAN_DETAILS,
    createRequestSaga(fetchFloorplanDetails, {
      key: 'floorplan',
      message: __('Looking for floor plans'),
    }),
  )
}

export function* watchRequestTransferUnitSearch() {
  yield takeLatest(
    REQUEST_TRANSFER_UNIT_SEARCH,
    createRequestSaga(getTransferUnitSearch, {
      key: 'floorplan',
      message: __('Looking for your information'),
    }),
  )
}

export function* submitRenewalTransfer({ payload, callback }) {
  const response = yield call(Api.postRenewalTransferRequest, payload)
  yield put(requestAlerts())
  typeof callback === 'function' && callback(response)
}

export function* watchProcessTransferRequest() {
  yield takeLatest(
    PROCESS_TRANSFER_REQUEST,
    createRequestSaga(submitRenewalTransfer, {
      key: 'renewalTransfer',
      message: __('Submitting renewal transfer'),
      successMessage: __('Transfer renewal submitted successfully'),
      write: true,
    }),
  )
}

export function* submitRenewalRequest({ payload }) {
  yield call(Api.postRenewalrequest, payload)
}

export function* watchProcessRenewalRequest() {
  yield takeLatest(
    PROCESS_RENEWAL_REQUEST,
    createRequestSaga(submitRenewalRequest, {
      key: 'renewalRequest',
      message: __('Submitting renewal request'),
      successMessage: __('Renewal request submitted successfully'),
      write: true,
    }),
  )
}

function* fetchRenewalRequestDetails() {
  const renewalRequestDetails = yield call(Api.getRenewalRequestDetails)
  yield put(
    receiveRenewalRequestDetails({ renewalRequest: renewalRequestDetails }),
  )
}

export function* watchGetRenewalRequestDetails() {
  yield takeLatest(
    GET_RENEWAL_REQUEST_DETAILS,
    createRequestSaga(fetchRenewalRequestDetails, {
      key: 'renewalRequest',
      message: __('Looking for renewal request'),
    }),
  )
}

function* cancelRenewalRequest({ payload }) {
  yield call(Api.cancelRenewalRequest, payload)
  yield put({ type: CANCEL_RENEWAL_REQUEST, payload: payload })
}

export function* watchCancelRenewalRequest() {
  yield takeLatest(
    REQUEST_CANCEL_RENEWAL_REQUEST,
    createRequestSaga(cancelRenewalRequest, {
      key: 'renewalRequest',
      message: __('Canceling the renewal request'),
      write: true,
    }),
  )
}

export function* submitRenewalSignal({ payload }) {
  yield call(Api.postRenewalSignal, payload)
}

export function* watchSendRenewalSignal() {
  yield takeLatest(
    SEND_RENEWAL_SIGNAL,
    createRequestSaga(submitRenewalSignal, {
      key: 'renewalSignal',
      message: __('Sending renewal signal'),
      successMessage: __('Renewal signal sent successfully'),
      write: true,
    }),
  )
}

export const sagas = [
  // watchAutopaymentSaveForRenewal,
  watchDeleteOccupant,
  watchPetDetails,
  watchRequestCompleteRenewal,
  // watchRequestAutoPayments,
  watchRequestOccupantInfo,
  watchRequestRenewalEmployers,
  watchRequestRentedItems,
  watchRequestRenewalOffers,
  watchRequestRenewalPersonalInfo,
  watchCreateMtomInterval,
  watchFloorplanDetails,
  watchRequestTransferUnitSearch,
  watchFloorPlanUnitDetails,
  watchProcessTransferRequest,
  watchFloorplanLeaseTerm,
  watchProcessRenewalRequest,
  watchGetRenewalRequestDetails,
  watchCancelRenewalRequest,
  watchRequestIncentives,
  watchSendRenewalSignal,
]
